import { defineMessage } from '@redbubble/next/intl';
import ex3FImg from '../assets/models/ex3_f.png';
import ex3MImg from '../assets/models/ex3_m.png';
import { PreQuerySizeGuideData } from '../types';
import {
  howToChooseSizeTshirtInstructions,
  internationalConversions,
  TSHIRT_ILLUSTRATION_PATH,
} from './sharedSizeGuideData';

/**
 * Experience 3
 * Essential T-Shirt
 * cluey-kookaburra
 * Data source: https://www.figma.com/file/APrcJzL2qFEoaRd5cHKcR6/Sizing---VM?node-id=102%3A1188&t=HmvOZ0xrFXTSRYSx-1
 */

export const experience3: PreQuerySizeGuideData = {
  internationalConversions,
  fitIndicator: {
    value: 2.5 /* 1 - 10 */,
  },
  howToChooseSize: {
    imageUrl: TSHIRT_ILLUSTRATION_PATH,
    instructions: howToChooseSizeTshirtInstructions,
  },
  model: {
    male: {
      imageUrl: ex3MImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Large. He usually wears a size Large.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 188 cm / 6’2”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 53.5 cm / 21”',
        }),
      ],
    },
    female: {
      imageUrl: ex3FImg.src,
      modelSize: defineMessage({
        defaultMessage:
          'Model is wearing size Small. She usually wears a size Small.',
      }),
      modelMeasurements: [
        defineMessage({
          defaultMessage: 'Height: 160 cm / 5’3”',
        }),
        defineMessage({
          defaultMessage: 'Chest: 43 cm / 17”',
        }),
      ],
    },
  },
};
